var _path, _g, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1700_10917",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 15,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.67676H17.2101V18.2213H3V1.67676Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1700_10917)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81089 2.92676C5.43006 2.92676 4.28339 4.04509 4.25089 5.42426V14.3568C4.22089 15.7743 5.33756 16.9409 6.74172 16.9718H13.4776C14.8684 16.9218 15.9692 15.7743 15.9601 14.3609V6.95009L12.0984 2.92676H6.82089H6.81089ZM6.82089 18.2218H6.71589C4.62256 18.1768 2.95589 16.4368 3.00089 14.3434V5.40926C3.05006 3.34176 4.75672 1.67676 6.80839 1.67676H6.82339H12.3642C12.5342 1.67676 12.6967 1.74592 12.8151 1.86842L17.0367 6.26592C17.1476 6.38176 17.2101 6.53759 17.2101 6.69842V14.3568C17.2234 16.4476 15.5934 18.1468 13.4992 18.2218H6.82089Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5815 7.48699H14.2865C12.7607 7.48283 11.5215 6.23949 11.5215 4.71616V2.29199C11.5215 1.94699 11.8015 1.66699 12.1465 1.66699C12.4915 1.66699 12.7715 1.94699 12.7715 2.29199V4.71616C12.7715 5.55283 13.4515 6.23449 14.2882 6.23699H16.5815C16.9265 6.23699 17.2065 6.51699 17.2065 6.86199C17.2065 7.20699 16.9265 7.48699 16.5815 7.48699",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78516 13.917C9.44016 13.917 9.16016 13.637 9.16016 13.292V8.25781C9.16016 7.91281 9.44016 7.63281 9.78516 7.63281C10.1302 7.63281 10.4102 7.91281 10.4102 8.25781V13.292C10.4102 13.637 10.1302 13.917 9.78516 13.917",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7847 13.9164C9.61887 13.9164 9.45887 13.8506 9.3422 13.7322L7.38804 11.7706C7.1447 11.5256 7.14554 11.1297 7.3897 10.8864C7.6347 10.6431 8.03054 10.6431 8.27387 10.8881L9.7847 12.4064L11.2955 10.8881C11.5389 10.6431 11.9347 10.6431 12.1797 10.8864C12.4239 11.1297 12.4247 11.5256 12.1814 11.7706L10.2272 13.7322C10.1105 13.8506 9.95053 13.9164 9.7847 13.9164",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFile);
export default __webpack_public_path__ + "static/media/export_file.3ea8fc54.svg";
export { ForwardRef as ReactComponent };